/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

import { UserModel } from '@/api/service-point/user/user.model';

/**
 * Export `ServicePointModel`.
 */
@endpoint('servicePoint')
export class ServicePointModel extends BaseModel {
  /**
   * Properties.
   */
  id: number;

  city: string;

  code: string;

  configs?: {
    ServicePointAcceptCollects?: string;
    ServicePointAcceptIce?: string;
  };

  countryCode: string;

  countryName: string;

  description: string;

  doorNumber: string;

  latitude: number;

  longitude: number;

  name: string;

  owner: UserModel;

  phone: string;

  street: string;

  zipCode: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<ServicePointModel>) {
    super(data);
  }
}
